// extracted by mini-css-extract-plugin
module.exports = {"multiWrapper":"MetricsWidgetWrapper_multiWrapper__2HpEU"};